import { get } from 'lodash';
import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import showcaseActionKeys from './showcaseActionKeys';
import * as showcaseActions from './showcaseActions';
import profileActions from '../../profile/common/profileActions';
import imageActionKeys from '../../../app/common/images/imagesActionKeys';
import type { AsyncState } from '../../../app/types';

export type ShowcaseReducerState = {
  getReviews: AsyncState<{}, {}>,
};

export default combineReducers({
  addFromGallery: AsyncRequest.createReducer(showcaseActionKeys.ADD_IMAGE_FROM_GALLERY),
  attachReview: AsyncRequest.createReducer(showcaseActionKeys.ATTACH_REVIEW, {
    [showcaseActionKeys.ATTACH_REVIEW_RESET]: state => state.merge({
      isLoading: false,
      request: null,
      response: null,
      error: null,
    }),
  }),
  imageGallery: AsyncRequest.createReducer(imageActionKeys.GET_PHOTOS, {
    [imageActionKeys.GET_PHOTOS_SUCCESS]: (state, action) => {
      const imageList = get(state.toJS(), 'response.images', []);
      return AsyncRequest.setSuccess(state, {
        images: [...imageList, ...get(action, 'payload.body.images', [])],
      });
    },
  }),
  getCategories: AsyncRequest.createReducer(showcaseActionKeys.GET_CATEGORIES),
  getReviews: AsyncRequest.createReducer(showcaseActionKeys.GET_REVIEWS, {
    [showcaseActionKeys.GET_REVIEWS_SUCCESS]: (state, action) => {
      const currentReviews = get(state.toJS(), 'response.reviews', []);
      return AsyncRequest.setSuccess(state, {
        reviews: [...currentReviews, ...get(action, 'payload.body.reviews', [])],
        total: get(action, 'payload.body.total'),
      });
    },
    [showcaseActionKeys.GET_REVIEWS_RESET]: state => state.merge({
      isLoading: false,
      request: null,
      response: null,
      error: null,
    }),
  }),
  getShowcase: AsyncRequest.createReducer(showcaseActionKeys.GET_SHOWCASE, {
    [showcaseActionKeys.ADD_IMAGE_FROM_GALLERY_SUCCESS]: (state, action) => {
      const media = get(state.toJS(), 'response.media');
      const newMedia = get(action, 'payload.body.media', []);
      return state.setIn(['response', 'media'], [...media, ...newMedia]);
    },
    [showcaseActionKeys.GET_SHOWCASE_RESET]: state => state.merge({
      isLoading: false,
      request: null,
      response: null,
      error: null,
    }),
  }),
  saveShowcase: AsyncRequest.createReducer(showcaseActionKeys.SAVE_SHOWCASE),
  saveMedia: AsyncRequest.createReducer(showcaseActionKeys.SAVE_MEDIA, {
    [showcaseActionKeys.SAVE_MEDIA_SUCCESS]: (state, action) => {
      action.addSideEffect((store) => {
        const storeState = store.getState();
        const serviceProviderId = get(storeState, 'serviceProviderId');
        const showcaseId = get(storeState, 'showcase.getShowcase.response.showcaseId');

        store.dispatch(showcaseActions.getShowcase(serviceProviderId, +showcaseId));
      });
      return AsyncRequest.setSuccess(state, action.payload);
    },
    [showcaseActionKeys.SAVE_MEDIA_RESET]: state => state.merge({
      isLoading: false,
      request: null,
      response: null,
      error: null,
    }),
  }),
  saveMediaOrder: AsyncRequest.createReducer(showcaseActionKeys.SAVE_MEDIA_ORDER),
  saveShowcaseOrder: AsyncRequest.createReducer(showcaseActionKeys.SAVE_SHOWCASE_ORDER, {
    [showcaseActionKeys.SAVE_SHOWCASE_ORDER_SUCCESS]: (state, action) => {
      action.addSideEffect((store) => {
        const storeState = store.getState();
        const serviceProviderId = get(storeState, 'serviceProviderId');
        store.dispatch(profileActions.getShowcases(serviceProviderId, ['Draft', 'Published']));
      });
      return AsyncRequest.setSuccess(state, action.payload.body);
    },
  }),
  publishShowcase: AsyncRequest.createReducer(showcaseActionKeys.PUBLISH_SHOWCASE),
  deleteMedia: AsyncRequest.createReducer(showcaseActionKeys.DELETE_MEDIA, {
    [showcaseActionKeys.DELETE_MEDIA_SUCCESS]: (state, action) => {
      action.addSideEffect((store) => {
        const storeState = store.getState();
        const serviceProviderId = get(storeState, 'serviceProviderId');
        const showcaseId = get(storeState, 'showcase.getShowcase.response.showcaseId');

        store.dispatch(showcaseActions.getShowcase(serviceProviderId, +showcaseId));
      });
      return AsyncRequest.setSuccess(state, action.payload.body);
    },
  }),
  updateShowcaseMedia: AsyncRequest.createReducer(showcaseActionKeys.UPDATE_SHOWCASE_MEDIA, {
    [showcaseActionKeys.UPDATE_SHOWCASE_MEDIA_SUCCESS]: (state, action) => {
      action.addSideEffect((store) => {
        const storeState = store.getState();
        const serviceProviderId = get(storeState, 'serviceProviderId');
        const showcaseId = get(storeState, 'showcase.getShowcase.response.showcaseId');

        if (action.meta.refetchShowcase) {
          store.dispatch(showcaseActions.getShowcase(serviceProviderId, +showcaseId));
        }
      });
      return AsyncRequest.setSuccess(state, action.payload.body);
    },
    [showcaseActionKeys.UPDATE_SHOWCASE_MEDIA_RESET]: (state, action) => {
      action.addSideEffect((store) => {
        const storeState = store.getState();
        const serviceProviderId = get(storeState, 'serviceProviderId');
        const showcaseId = get(storeState, 'showcase.getShowcase.response.showcaseId');

        store.dispatch(showcaseActions.getShowcase(serviceProviderId, +showcaseId));
      });
      return AsyncRequest.setSuccess(state);
    },
  }),
});



// WEBPACK FOOTER //
// ./src/modules/showcase/common/showcaseReducer.js